import { takeLatest, put, call, select } from 'redux-saga/effects';
import { REMOVE_SUBSCRIPTION_WORKOUT_SAGA } from "../sagaTypes";
import { loaderAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getSubscriptionDataSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/remove_subscription_workout`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerRemoveSubscriptionWorkout(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('id', args.data.id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            yield put(getSubscriptionDataSagaAction());
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherRemoveSubscriptionWorkout() {
    yield takeLatest(REMOVE_SUBSCRIPTION_WORKOUT_SAGA, workerRemoveSubscriptionWorkout);
}